import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { To, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { onActivationKey } from "src/app/utils/keyboard";

const Page401 = ({ to = "/landing" }: { to?: To }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="tpr flex w-full flex-col  ">
      <div className="nav flex">
        <div
          role="button"
          tabIndex={0}
          onClick={() => navigate(to)}
          onKeyDown={onActivationKey(() => navigate(to))}
          className="tpr-name text-white uppercase pl-8 cursor-pointer pt-6 pb-2 text-lg flex items-center mb-4"
        >
          <ArrowBackIosNewIcon />
          <p className="pl-4">{t("messages.go-back")}</p>
        </div>
      </div>
      <div className="relative flex items-center justify-center h-[90vh]">
        <img
          src="/assets/images/401.png"
          alt=""
          className=" object-contain  w-[50%] h-[50%] m-auto "
        />
        <span className=" text-white text-center absolute bottom-[15%] left-[50%]">
          {t("messages.401")}
        </span>
      </div>
    </div>
  );
};

export default Page401;
